import React, { useMemo } from "react";

import DOMPurify from "dompurify";

import Thumbnail from "src/components/thumbnail";

import _ from "lodash";
import cx from "classnames";
import styles from "./about.module.scss";
import { Media } from "src/types/media";

export const SimulationInfo = ({ scenario }) => {
  const interaction = useMemo(
    () => _.get(scenario, "prospect.interactionWithSales"),
    [scenario],
  );
  const description = useMemo(
    () => _.get(scenario, "company.summary"),
    [scenario],
  );

  const duration = useMemo(
    () => _.get(scenario, "callSettings.duration"),
    [scenario],
  );
  const industry = useMemo(
    () => _.get(scenario, "company.industry"),
    [scenario],
  );
  return (
    <section className={styles.simulationInfo}>
      <span className={styles.title}>
        {_.get(scenario, "name")}
      </span>
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(interaction) }}
      />
      <div className={styles.actions}>
        <div className={styles.item}>
          <i className="paperflite-clock"></i>
          <span>{duration} minutes</span>
        </div>
        <div className={styles.border} />
        <div className={styles.item}>
          <i className="paperflite-document" />
          <span>Discovery call</span>
        </div>
        <div className={styles.border} />
        <div className={styles.item}>
          <i className="paperflite-rocket" />
          <span>{industry}</span>
        </div>
      </div>
    </section>
  );
};

export const Persona = ({ prospect }) => {
  const profileImage = useMemo(() => {
    const image = _.get(prospect, "profileImage");
    if (image) {
      return {
        id: image,
        key: image,
        type: "image",
      } as Media;
    }

    return null;
  }, [prospect]);

  return (
    <section className={styles.persona}>
      <h3 className={styles.header}>Persona</h3>
      <div className={styles.avatar}>
        <Thumbnail
          className={styles.thumbnail}
          media={profileImage}
          defaultImage="/images/coaching/default_course.jpg"
        />
        <span className={styles.name}>{_.get(prospect, "name")}</span>
      </div>
      <p className={styles.summary}>{_.get(prospect, "summary")}</p>
    </section>
  );
};

export const OrganizationInfo = ({ company }) => {
  return (
    <section className={styles.organizationInfo}>
      <h3 className={styles.header}>Organization Info</h3>
      <span className={styles.title}>{company?.name}</span>
      <p className={styles.summary}>{company?.summary}</p>
    </section>
  );
};
